import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { CanalAndTubewellBased } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-canal-and-tube-well-based-report',
  templateUrl: './canal-and-tube-well-based-report.component.html',
  styleUrls: ['./canal-and-tube-well-based-report.component.scss']
})
export class CanalAndTubeWellBasedReportComponent implements OnInit {

  canalAndTubeWell: any[];
  totalAppReceived:number;
  totalArea:number;
  totalVerfApp:number;
  totalVerfArea:number;
  totalEstApproved:number;
  totalEstPending:number;
  totalBoqUploaded:number;
  totalBoqPending:number;
  totalPvApproved:number;
  totalPvPending:number;
  totalDmicadaApproved:number;
  totalDmicadaPending:number;
  grandtotalAppReceived:number;
  grandTotalArea:number;
  grandTotalVerfApp:number;
  grandTotalVerfArea:number;
  grandTotalEstApproved:number;
  grandTotalEstPending:number;
  grandTotalBoqUploaded:number;
  grandTotalBoqPending:number;
  grandTotalPvApproved:number;
  grandTotalPvPending:number;
  grandTotalDmicadaApproved:number;
  grandTotalDmicadaPending:number;
  arrayIndex:number;
  tempcanalAndTubeWell: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: CanalAndTubewellBased[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;

  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Stage3_Subsidy_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Stage3_Subsidy_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
     // this.loader.start();
     this.loading = true;
    let sub=this.reportsService.getCanalAndTubewell_BasedReport(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Canal and TubeWell Based Report', '', new Date(), 'Success');

            if (data?.length > 0) {
              this.canalAndTubeWell = data;
              this.appVerificationModel = data;
              this.tempcanalAndTubeWell=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.canalAndTubeWell =[] ;
              this.appVerificationModel =[] ;
              this.tempcanalAndTubeWell=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Canal and TubeWell Based Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Water Source" : d.Water_Source,
          "Application Recieved" : d.ApplicationRecieved,
          "Total Area": d.TotalArea,
          "Verified Application": d.Verified_Application,
          "App Verified Area": d.App_Verified_Area,
          "estimate Approved": d.estimateApproved,
          "estimate Pending": d.estimatePending,
          "BOQ Uploaded": d.BOQ_Uploaded,
          "BOQ Pending": d.BOQ_Pending,
          "PV Approved": d.PV_Approved,
          "PV Pending": d.PV_Pending,
          "DMICADA Approved": d.DMICADA_Approved,
          "DMICADA Pending": d.DMICADA_Pending,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'Water_Source', header: 'Water Source'},
      {field: 'ApplicationRecieved', header: 'Application Recieved'},
      {field: 'TotalArea', header: 'Total Area' },
      {field: 'Verified_Application', header: 'Verified Application' },
      {field: 'App_Verified_Area', header: 'App Verified Area'},
      {field: 'estimateApproved', header: 'estimate Approved'},
      {field: 'estimatePending', header: 'estimate Pending'},
      {field: 'BOQ_Uploaded', header: 'BOQ Uploaded'},
      {field: 'BOQ_Pending', header: 'BOQ Pending'},
      {field: 'PV_Approved', header: 'PV Approved'},
      {field: 'PV_Pending', header: 'PV Pending'},
      {field: 'DMICADA_Approved', header: 'DMICADA Approved'},
      {field: 'DMICADA_Pending', header: 'DMICADA Pending'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempcanalAndTubeWell=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
       this.totalAppReceived=0;
       this.totalArea=0;
       this.totalVerfApp=0;
       this.totalVerfArea=0;
       this.totalEstApproved=0;
       this.totalEstPending=0;
       this.totalBoqUploaded=0;
       this.totalBoqPending=0;
       this.totalPvApproved=0;
       this.totalPvPending=0;
       this.totalDmicadaApproved=0;
       this.totalDmicadaPending=0;
        
          for(let i=this.arrayIndex ;this.tempcanalAndTubeWell.length>10?i<this.arrayIndex+10:i<this.tempcanalAndTubeWell.length;i++) {
            this.totalAppReceived +=this.tempcanalAndTubeWell[i].ApplicationRecieved;
            this.totalArea +=this.tempcanalAndTubeWell[i].TotalArea;
            this.totalVerfApp +=this.tempcanalAndTubeWell[i].Verified_Application;
            this.totalVerfArea += this.tempcanalAndTubeWell[i].App_Verified_Area;
            this.totalEstApproved += this.tempcanalAndTubeWell[i].estimateApproved;
            this.totalEstPending += this.tempcanalAndTubeWell[i].estimatePending;
            this.totalBoqUploaded += this.tempcanalAndTubeWell[i].BOQ_Uploaded;
            this.totalBoqPending +=this.tempcanalAndTubeWell[i].BOQ_Pending;
            this.totalPvApproved +=this.tempcanalAndTubeWell[i].PV_Approved;
            this.totalPvPending +=this.tempcanalAndTubeWell[i].PV_Pending;
            this.totalDmicadaApproved +=this.tempcanalAndTubeWell[i].DMICADA_Approved;
            this.totalDmicadaPending +=this.tempcanalAndTubeWell[i].DMICADA_Pending;
  
          }

        
              
    }
    calculateGrandTotal(){
      this.grandtotalAppReceived=0;
      this.grandTotalArea=0;
      this.grandTotalVerfApp=0;
      this.grandTotalVerfArea=0;
      this.grandTotalEstApproved=0;
      this.grandTotalEstPending=0;
      this.grandTotalBoqUploaded=0;
      this.grandTotalBoqPending=0;
      this.grandTotalPvApproved=0;
      this.grandTotalPvPending=0;
      this.grandTotalDmicadaApproved=0;
      this.grandTotalDmicadaPending=0;
      for(let stage1Data of this.tempcanalAndTubeWell) {
        this.grandtotalAppReceived += stage1Data.ApplicationRecieved;
        this.grandTotalArea += stage1Data.TotalArea;
        this.grandTotalVerfApp += stage1Data.Verified_Application;
        this.grandTotalVerfArea += stage1Data.App_Verified_Area;
        this.grandTotalEstApproved += stage1Data.estimateApproved;
        this.grandTotalEstPending += stage1Data.estimatePending;
        this.grandTotalBoqUploaded += stage1Data.BOQ_Uploaded;
        this.grandTotalBoqPending += stage1Data.BOQ_Pending;
        this.grandTotalPvApproved += stage1Data.PV_Approved;
        this.grandTotalPvPending += stage1Data.PV_Pending;
        this.grandTotalDmicadaApproved += stage1Data.DMICADA_Approved;
        this.grandTotalDmicadaPending += stage1Data.DMICADA_Pending;
    }
    }

}
